module.exports = __webpack_public_path__ + "static/img/star@2x.010d110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/star@2x.png
// module id = GBdf
// module chunks = 1